import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const questionService = {
  list: params => axios.get(Pathes.Help.forumMessages + getQuery(params)),
  create: payload => axios.post(Pathes.Help.forumMessages, payload),
};
